import axios from "axios";

/**
 *
 * @status no delete
 * @class OnboardingUserService
 */
class OnboardingUserService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl;
  }

  /**
  * @author Brayan Salas
  * @description Get onboarding user step
  * @date 20-08-2024
  * @param {String} token
  * @returns {Object}
  * @memberof OnboardingUserService
  */
  async getStepOnboarding(token) {
    let response = await axios.get(
      `${this.apiUrl}/onboarding-user-passthrough?origin=internal`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  }

  /**
  * @author Brayan Salas
  * @description Get onboarding user step Admin
  * @date 20-08-2024
  * @param {String} token
  * @returns {Object}
  * @memberof OnboardingUserService
  */
  async getStepOnboardingAdmin(token) {
    let response = await axios.get(
      `${this.apiUrl}/onboarding-admin-passthrough`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  }
}

export { OnboardingUserService as default };